// M004-F0634 §1 (UI-3) — the /app/ledgerApprovals redirect.
//
// Core's `ledger_dispatch_awaiting_approval` notification deep link emitted
// `/app/ledgerApprovals?orgId=&postingId=` (ML001-D014 §5b.4). That page was
// NEVER merged (the !342 page is replaced by the Billing tab before it ever
// shipped to main); the path stays alive for one release as a REDIRECT so
// notifications already delivered still land — on
// /app/bookings?tab=billing&view=need… the canonical surface.
//
// The notification carries a POSTING id, which under §0a IS the billing
// item id (Core §5d.4.1: one shared identifier) — the redirect forwards it
// as `posting=<postingId>` and the Billing tab opens that item's drawer
// once the view has loaded. The default view is the §0a.1 default
// (need — "Needs approval"); the superseded board's stage vocabulary is
// gone.
import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// Pure target builder (jest-tested): the redirect target for the legacy
// deep link's query parameters.
export const ledgerApprovalsRedirectTarget = (orgId, postingId) => {
  const search = new URLSearchParams();
  search.set('tab', 'billing');
  search.set('view', 'need');
  if (postingId) search.set('posting', String(postingId));
  if (orgId) search.set('org', String(orgId));
  return { pathname: '/app/bookings', search: search.toString() };
};

const LedgerApprovalsRedirect = () => {
  const [searchParams] = useSearchParams();
  return (
    <Navigate
      replace
      to={ledgerApprovalsRedirectTarget(
        searchParams.get('orgId'),
        searchParams.get('postingId'),
      )}
    />
  );
};

export default LedgerApprovalsRedirect;
